import { Component, OnInit } from '@angular/core';
import { Item } from '@app/core/components/listbox/listbox.component';
import { ShiftPlanService } from '@app/services/shift-plan.service';

@Component({
  selector: 'tt-shift-plans',
  templateUrl: './shift-plans.component.html',
  styleUrls: ['./shift-plans.component.css'],
  standalone: false,
})
export class ShiftPlansComponent implements OnInit {
    public plans: Item[] = [];
    constructor(private readonly shiftPlan: ShiftPlanService) {}
    public async ngOnInit(): Promise<void> { this.plans = await this.shiftPlan.getPlans(); }
}
